module.exports = __webpack_public_path__ + "static/mpost37.1f552923.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost37.jpg
// module id = 252
// module chunks = 35783957827783 269829036549620